module.exports = function() {
  return new Worker(__webpack_public_path__ + "c1fb84c8fae1bb60003b.worker.js");
};